export class ApplicationUserList {
    Id: number;
    UserName: string;
    Email: string;
    clinic_no: number;
    clinic_name: string;
    RoleId: number;
    RoleName: string;
    AppUserRoleId: number;
    tenant_no: number;
    tenant_name: string;


    constructor(
        Id: number, 
        UserName: string, 
        Email: string, 
        clinic_no: number, 
        clinic_name: string, 
        RoleId: number, 
        RoleName: string, 
        AppUserRoleId: number,
        tenant_no: number,
        tenant_name: string
    ) {
        this.Id = Id;
        this.UserName = UserName;
        this.Email = Email;
        this.clinic_no = clinic_no;
        this.clinic_name = clinic_name;
        this.RoleId = RoleId;
        this.RoleName = RoleName;
        this.AppUserRoleId = AppUserRoleId;
        this.tenant_no = tenant_no;
        this.tenant_name = tenant_name; 
    }
} 